export const LT_ANON = 'anon';
export const LT_ECOM = 'ecom';

export type LoginType = (
  | typeof LT_ANON
  | typeof LT_ECOM
);
